"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Pencil } from "lucide-react"
import { ReviewForm, type ReviewFormInitial } from "@/components/ReviewForm"

/**
 * Entry point for editing your own review. Collapsed by default (the review
 * already renders in the list above); clicking Edit reveals the pre-filled
 * ReviewForm in edit mode, which PATCHes on save.
 */
export function EditReviewSection({
  residencyId,
  initial,
}: {
  residencyId: string
  initial: ReviewFormInitial
}) {
  const [editing, setEditing] = useState(false)

  if (!editing) {
    return (
      <div className="border border-[var(--border)] rounded-xl p-5 flex items-center justify-between gap-4">
        <p className="text-sm text-[var(--muted-foreground)]">
          You&apos;ve reviewed this residency. Need to change something?
        </p>
        <Button size="sm" variant="outline" className="gap-1.5" onClick={() => setEditing(true)}>
          <Pencil size={13} /> Edit review
        </Button>
      </div>
    )
  }

  return (
    <ReviewForm residencyId={residencyId} initial={initial} onCancel={() => setEditing(false)} />
  )
}
